import { useState, useEffect } from 'react';
import axios from '../../../../api/axios';
import { getLanguageConfig } from '../../../../utils/code/languageConfig';

/**
 * 题目数据管理 Hook
 * 负责获取和管理题目数据
 */
export function useQuestion(questionId) {
  const [question, setQuestion] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Early return if questionId is invalid or undefined
    if (!questionId || questionId === 'undefined' || questionId === 'null') {
      setLoading(false);
      setError('题目ID无效');
      return;
    }
    fetchQuestion();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questionId]);

  const fetchQuestion = async () => {
    // Early return if questionId is invalid
    if (!questionId || questionId === 'undefined') {
      setLoading(false);
      setError('题目ID无效');
      return;
    }
    
    try {
      setLoading(true);
      setError(null);
      const response = await axios.get(`/questions/${questionId}`);
      setQuestion(response.data);
    } catch (error) {
      console.error('Error fetching question:', error);
      setError(error.response?.data?.error || '加载题目失败，请重试');
    } finally {
      setLoading(false);
    }
  };

  const updateQuestion = (updates) => {
    if (!updates) return;
    // If updates is a full question object, use it directly
    // Otherwise merge with existing question
    if (updates.id || updates.templateCode !== undefined) {
      setQuestion(updates);
    } else {
      setQuestion(prev => (prev ? { ...prev, ...updates } : updates));
    }
  };

  const saveDifficulty = async (newDifficulty) => {
    if (!questionId || questionId === 'undefined' || questionId === 'null') return;
    try {
      const response = await axios.put(`/questions/${questionId}`, { difficulty: newDifficulty });
      if (response.data?.question) {
        updateQuestion(response.data.question);
      } else {
        updateQuestion({ difficulty: newDifficulty });
      }
    } catch (err) {
      console.error('Failed to update difficulty', err);
    }
  };

  const getEditorLanguage = () => {
    if (!question) return 'python';
    const lang = question.language || 'python';
    return getLanguageConfig(lang).monacoLanguage;
  };

  const getInitialCode = () => {
    if (!question) return '';
    // Use latest submission code if available, otherwise use template
    if (question.latestSubmission && question.latestSubmission.code) {
      return question.latestSubmission.code;
    }
    return question.templateCode || '';
  };

  return {
    question,
    loading,
    error,
    refetch: fetchQuestion,
    updateQuestion,
    saveDifficulty,
    getEditorLanguage,
    getInitialCode
  };
}

